import React from "react";
import styled, { css } from "styled-components";
import Loading from "../Loading";
import MapContext from "../MapContext";

import flags from "../../data/flags.json";

class Countries extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            countries: [],
            loading: false
        }
    }

    componentDidMount() {
        this.setState({ loading: true });

        import("../../data/countries.json")
            .then(data => {
                this.setState({
                    countries: data.default.countries,
                    loading: false
                })
            })
    }

    render() {
        return <MapContext.Consumer>
            {({ mode }) => {
                return <Container>
                    <Title>Countries ranked by contribution</Title>
                    <Loading isDisplayed={ this.state.loading } />
                    <CountriesWrapper>
                        { this.state.countries.map((country, index) => {
                            const { contributions, country: name } = country;
                            const iso = flags[name];

                            return <CountryWrapper key={ index } mode={ mode }>
                                <RankWrapper>
                                    <p style={{ fontSize: 18, fontWeight: "bold" }}>{ index + 1}</p>
                                    <CountryFlag>
                                        <img 
                                            src={ require(`../../assets/flags/${ iso }.png`) } 
                                            alt={ `${ country } flag` } />
                                    </CountryFlag>
                                </RankWrapper>
                                <CountryName>{ name }</CountryName>
                                <CountryContributions>{ new Intl.NumberFormat('en').format(contributions) }</CountryContributions>
                            </CountryWrapper>
                        })}
                    </CountriesWrapper>
                </Container>
            }}
        </MapContext.Consumer>
    }
}

const Container = styled.div`
    width: 100%;
    padding: 8px 9px;
`

const Title = styled.h2`
    font-size: 18px;
    text-align: center;
    margin: 12px 0;
`

const CountriesWrapper = styled.div`
`

const CountryWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 12px;
    padding: 8px;
    border-radius: 5px;

    background: #e2e2e2;
    ${ props => props.mode === "dark" && css`
        background: #353535;
    ` }
`

const CountryFlag = styled.div`
    width: 26px;
    img {  width: 100%; }
`

const RankWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`

const CountryName = styled.p`
    font-weight: bold;
    text-transform: capitalize;
    font-size: 16px;
    text-align: center;
    max-width: 100px;
`

const CountryContributions = styled.p`
    font-weight: bold;
`

const LegendWrapper = styled.div`
    border: 1px solid grey;
    padding: 12px;
`

const ColorMeta = styled.div`
    display: flex;
    align-items: center;
    font-size: 12px;
    font-weight: bold;
    margin-bottom: 6px;
`

const Preview = styled.div`
    width: 15px;
    height: 15px;
    margin-right: 8px;
    ${ props => css`background: ${ props.color };`}
`

export default Countries;